import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CompanyStakeholderDto, HumanStakeholderDto } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useCreate = () => {
  const { locale } = useLocale();

  const { mutate: createHuman, isPending: isPendingHuman } = useAppMutation(
    [QueryKey.CREATE_HUMAN_STAKEHOLDER],
    {
      mutationFn: ({ companyId, data }: { companyId: string; data: HumanStakeholderDto }) =>
        ApiService.post(
          { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'stakeholders', 'human'] },
          {
            body: data,
            locale,
          },
        ),
    },
  );

  const { mutate: createCompany, isPending: isPendingCompany } = useAppMutation(
    [QueryKey.CREATE_COMPANY_STAKEHOLDER],
    {
      mutationFn: ({ companyId, data }: { companyId: string; data: CompanyStakeholderDto }) =>
        ApiService.post(
          { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'stakeholders', 'company'] },
          { body: data, locale },
        ),
    },
  );

  return {
    createHuman,
    createCompany,
    isPendingCompany,
    isPendingHuman,
  };
};
